export default __webpack_public_path__ + "static/silkserif-extralight-italic-f7554bf635970021020722e64baf6c10.woff";